/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import styles from './styles';

class BleServices extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  startScan() {
    const success = () => {
      console.log('Start');
    };
    const failure = () => {
      console.log('Fail');
    };
    window.ble.startScan(['org.bluetooth.service.user_data'] , success, failure);
  }

  stopScan() {
    const success = () => {
      console.log('Start');
    };
    const failure = () => {
      console.log('Fail');
    };
    window.ble.stopScan(success, failure);
  }

  render() {
    const { t, classes } = this.props;
    return (
      <div className={classes.container}>
        <br />
        <br />
        <h3>{t('screens.BLE.title1')}</h3>
        <br />
        <br />
        <h3>
          {t('screens.BLE.title6')}
        </h3>
        <br />
        <ButtonGroup size="small" color="primary">
          <Button onClick={() => this.startScan()}>
            {t('screens.BLE.button1')}
          </Button>
          <Button onClick={() => this.stopScan()}>
            {t('screens.BLE.button2')}
          </Button>
          <Button>
            {t('screens.BLE.button3')}
          </Button>
          <Button>
            {t('screens.BLE.button4')}
          </Button>
        </ButtonGroup>
      </div>
    );
  }
}

BleServices.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(
  withStyles(styles)(BleServices),
);
